export function safeGetStorageItem(storage, key, fallback = '') {
  if (!storage || typeof storage.getItem !== 'function') return fallback
  try {
    const value = storage.getItem(key)
    return value == null ? fallback : value
  } catch (e) {
    return fallback
  }
}

export function safeSetStorageItem(storage, key, value) {
  if (!storage || typeof storage.setItem !== 'function') return false
  try {
    storage.setItem(key, value)
    return true
  } catch (e) {
    return false
  }
}

export function safeRemoveStorageItem(storage, key) {
  if (!storage || typeof storage.removeItem !== 'function') return false
  try {
    storage.removeItem(key)
    return true
  } catch (e) {
    return false
  }
}

function isStorageLike(storage) {
  return !!storage &&
    typeof storage.getItem === 'function' &&
    typeof storage.setItem === 'function' &&
    typeof storage.removeItem === 'function'
}

function browserWindow() {
  try {
    if (typeof window !== 'undefined' && window) return window
  } catch (e) {
    return null
  }
  return null
}

export function safeLocalStorage() {
  try {
    const win = browserWindow()
    if (win && isStorageLike(win.localStorage)) return win.localStorage
  } catch (e) {
    return null
  }
  try {
    if (typeof localStorage !== 'undefined' && isStorageLike(localStorage)) return localStorage
  } catch (e) {
    return null
  }
  return null
}

export function safeSessionStorage() {
  try {
    const win = browserWindow()
    if (win && isStorageLike(win.sessionStorage)) return win.sessionStorage
  } catch (e) {
    return null
  }
  try {
    if (typeof sessionStorage !== 'undefined' && isStorageLike(sessionStorage)) return sessionStorage
  } catch (e) {
    return null
  }
  return null
}

export function safeStorageSnapshot(storage, keys, fallback = '') {
  const out = {}
  if (!Array.isArray(keys)) return out
  for (const key of keys) {
    const safeKey = String(key || '').trim()
    if (!safeKey) continue
    out[safeKey] = safeGetStorageItem(storage, safeKey, fallback)
  }
  return out
}
